import { TFunction } from 'i18next';

import { ReflexQuestion, ReflexStep } from 'shiftNotes/_types';

export const DEMO_REFLEX_ID = 'demo-reflex';

const now = new Date().toISOString();

const baseStep: Omit<ReflexStep, 'id' | 'step_type' | 'order' | 'title'> = {
  body: '',
  completed_at: null,
  form_instance: null,
  created: now,
  modified: now,
};

export function buildDemoQuestions(t: TFunction): ReflexQuestion[] {
  return [
    {
      id: 'demo-q-1',
      order: 0,
      question: t('demoReflex.missingInfoQuestion'),
      input_type: 'text',
      answer_text: '',
      answer_boolean: null,
      answer_date: null,
      created: now,
      modified: now,
    },
  ];
}

export interface DemoActionSteps {
  answerTitle: string;
  followUp: ReflexStep;
  photo: ReflexStep;
  escalation: ReflexStep;
}

export function buildDemoActionSteps(t: TFunction): DemoActionSteps {
  return {
    answerTitle: t('demoReflex.recommendedActionText'),
    followUp: {
      ...baseStep,
      id: 'demo-followup',
      step_type: 'text',
      order: 1,
      title: t('demoReflex.shiftIntelligenceText'),
    },
    photo: {
      ...baseStep,
      id: 'demo-photo',
      step_type: 'ask_for_photo',
      order: 2,
      title: t('demoReflex.captureEvidenceText'),
    },
    escalation: {
      ...baseStep,
      id: 'demo-escalation',
      step_type: 'compose_message',
      order: 3,
      title: t('demoReflex.escalateText'),
      body: t('demoReflex.escalationEmail'),
    },
  };
}
